'use strict';
import {storage} from '../../config/constants';
const angular = require('angular');
const {copy, isArray, isDefined, isFunction, isObject} = angular;

module.exports = [
  '$log',
  '$window',
  'DeviceServices',
  '$persistentCacheFactory',
  LocalFileDataService];

var $log;

var FILE_STORE_KEY = 'file-data-cache';
var COUNTER_KEY = FILE_STORE_KEY + '-COUNTER';
var DELETION_STRATEGIES = {};

Object.defineProperties(DELETION_STRATEGIES, {
  DURATION: {enumerable: true, value: 'duration'},
  QUOTA: {enumerable: true, value: 'quota'},
  ALL: {enumerable: true, value: 'all'}
});

if (isFunction(Object.freeze)) {
  Object.freeze(DELETION_STRATEGIES);
}

function LocalFileDataService(
  _$log,
  $window,
  DeviceServices,
  $persistentCacheFactory,
) {

  //TODO: retrieve deletion strategy from the current app settings
  this.deletionSettings = {
    strategy: DELETION_STRATEGIES.DURATION,
    duration: 24 * 3600 * 1000 /*default: 24 hours as milliseconds */
  };

  $log = _$log;

  Object.defineProperties(this, {
    'DELETION_STRATEGY': {value: DELETION_STRATEGIES},

    '$$window': {value: $window},
    '$$DeviceServices': {value: DeviceServices},

    '$$fileCache': {value: $persistentCacheFactory(FILE_STORE_KEY)},
    '$$fileEntries': {writable: true, value: {}},
    '$$counter': {writable: true, value: null},

    'operationInProgress': {writable: true, value: false}
  });

  _initializeCounter.call(this);
}

LocalFileDataService.prototype = {};
LocalFileDataService.prototype.size = size; //_.throttle(size, 2, {leading: true});
LocalFileDataService.prototype.getFile = getFile;
LocalFileDataService.prototype.getByKey = getByKey;
LocalFileDataService.prototype.getAll = getAll;
LocalFileDataService.prototype.bindToScope = bindToScope;
LocalFileDataService.prototype.addFile = addFile;
LocalFileDataService.prototype.addFiles = addFiles;
LocalFileDataService.prototype.deleteExpiredFiles = deleteExpiredFiles;
LocalFileDataService.prototype.getOrderedCache = getOrderedCache;
LocalFileDataService.prototype.getTotalFileSize = getTotalFileSize;

function getFile(key) {
  return copy(this.$$fileCache.get(key));
}

function getByKey(id) {
  var results = [];

  var data = this.$$fileCache.getAll();

  for (var key in data) {
    if (isObject(data[key]) && data[key].modelId === id) {
      results.push(data[key]);
    }
  }
  return results;
}

function getAll() {
  var results = [];

  var data = this.$$fileCache.getAll();

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      results.push(data[key]);
    }
  }
  return results;
}

//TODO(perf): This should really update the existing list rather than overwriting it every time...
function bindToScope(scope, name, id) {
  var self = this;
  var loadedOnce = false;
  var unwatch = scope.$watch(self.size.bind(self),
    function (newLen, oldLen) {
      if (isDefined(newLen) && (!loadedOnce || (newLen !== oldLen))) {
        loadedOnce = true;

        if (isDefined(id)) {
          scope[name] = self.getByKey(id);
        } else {
          scope[name] = self.getAll();
        }
      }
    });

  scope.$on('$destroy', unwatch);
}

//TODO(perf): This is questionable but for small caches it shouldn't be a performance concern. This is intended to be watched so the keys array may be computed multiple times per digest. Throttling should minimize the impact.
function size() {
  return this.$$fileCache.size();
}


/**
 *
 * @param {object} fileData object with key and collection parameters for the firebase object this file is associated with.
 * @returns {string} key cached upload key
 */
function addFile(fileData, addingMultiple) {
  fileData = fileData || {};

  var key = _generateKey.call(this);
  var now = new Date().getTime();
  var cache = {
    cacheId: key,
    key: fileData.key,

    name: fileData.name,
    filename: fileData.filename,
    fileUri: fileData.fileUri,

    type: fileData.type,
    size: fileData.size,

    dateCreated: now
  };

  this.$$fileCache.put(key, cache);

  _retrieveFile.call(this, key);

  $log.debug('FC.addFile key ' + fileData.key + ' key ' + key);

  if (!addingMultiple) {
    this.deleteExpiredFiles();
  }

  return key;
}

/**
 * @param {Array<object>} fileData object with key and collection parameters for the firebase object this file is associated with.
 * @returns {array} keys cached upload keys
 */
function addFiles(fileData) {
  if (isArray(fileData) && files.length === fileData.length) {
    var result = new Array(fileData.length);
    for (var i = 0; i < fileData.length; i++) {
      result[i] = this.addFile(fileData[i], true);
    }
    this.deleteExpiredFiles();
  } else {
    this.$log.error('LocalFileDataService.addFiles called with invalid arguments');
  }
}

function deleteExpiredFiles(deletionSettings) {
  if (this.operationInProgress) {
    var error = Promise.defer();
    error.reject('an operation is currently in progress');
    return error.promise;
  }

  this.operationInProgress = true;

  var self = this;
  var now = new Date().getTime();
  var cache = this.getOrderedCache();
  var filesToDelete = [];
  deletionSettings = deletionSettings || this.deletionSettings;
  var i;

  if (cache.length === 0) return Promise.resolve(null);

  if (deletionSettings.strategy === DELETION_STRATEGIES.ALL) {
    for (i = 0; i < cache.length; i++) {
      filesToDelete.push(_deleteExpiredFile.call(self, cache[i].cacheId));
    }
  } else if (deletionSettings.strategy === DELETION_STRATEGIES.DURATION) {
    for (i = cache.length - 1; i > -1; i--) {
      if (now - cache[i].dateCreated > this.deletionSettings.duration) {
        filesToDelete.push(_deleteExpiredFile.call(self, cache[i].cacheId));
      } else {
        break;
      }
    }
  } else if (deletionSettings === DELETION_STRATEGIES.QUOTA) {
    var totalFileSize = self.getTotalFileSize();
    var sizeToDelete = 0;

    for (i = cache.length - 1; i > -1; i--) {
      if (totalFileSize - sizeToDelete > this.deletionSettings.maxSize) {
        sizeToDelete += cache[i].size;
        filesToDelete.push(_deleteExpiredFile.call(self, cache[i].cacheId));
      } else {
        break;
      }
    }
  }

  var deferred = Promise.defer();
  Promise.all(filesToDelete).then(function (results) {
    self.operationInProgress = false;
    deferred.resolve(results);
  }, function (error) {
    self.operationInProgress = false;
    deferred.reject(error);
  });

  return deferred.promise;
}

function getOrderedCache() {
  var results = [];

  var data = this.$$fileCache.getAll();

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      results.push({
        dateCreated: data[key].dateCreated,
        size: data[key].size,
        cacheId: data[key].cacheId
      });
    }
  }

  // sort with oldest at the end.
  results.sort(function (a, b) {
    return b.dateCreated - a.dateCreated;
  });

  return results;
}

function getTotalFileSize() {
  var result = 0;

  var data = this.$$fileCache.getAll();

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      result += data[key].size;
    }
  }

  return result;
}


/***********************************************************************************************************************
 * Private Methods
 **********************************************************************************************************************/

//TODO: test
function _retrieveFile(key, successCallback, errorCallback) {
  var self = this;
  var fileData = this.$$fileCache.get(key);
  $log.debug('FC._retrieveFile key ' + key, fileData);

  if (self.$$fileEntries[key]) {
    isFunction(successCallback) && successCallback(self.$$fileEntries[key]);
  } else {
    try {
      self.$$window.resolveLocalFileSystemURI(fileData.fileUri, function (fileEntry) {
        self.$$fileEntries[key] = fileEntry;
        isFunction(successCallback) && successCallback(fileEntry);
      }, errorCallback);
    } catch (error) {
      $log.debug('FC._retrieveFile failed to retrieve file key ' + key);
      isFunction(errorCallback) && errorCallback(error);
    }
  }
}

function _deleteExpiredFile(key) {
  var deferred = Promise.defer();
  var self = this;

  _retrieveFile.call(self, key, deleteFile, deferred.reject.bind(deferred));

  function deleteFile(fileEntry) {
    fileEntry.remove(function () {
      _removeFileFromStorage.call(self, key);
      deferred.resolve();
    }, deferred.reject.bind(deferred));
  }

  return deferred.promise;
}

function _generateKey() {
  if (this.$$counter < 65535) {
    this.$$counter++;
  } else {
    this.$$counter = 0;
  }
  storage.set(COUNTER_KEY, '' + this.$$counter);
  return this.$$counter;
}

function _removeFileFromStorage(key) {

  // fire event that key is removed?

  this.$$fileCache.remove(key);
  delete this.$$fileEntries[key];
}

function _initializeCounter() {
  this.$$counter = storage.get(COUNTER_KEY);

  if (!this.$$counter) {
    this.$$counter = 1;
    storage.set(COUNTER_KEY, '1');
  } else {
    try {
      this.$$counter = parseInt(this.$$counter, 10);
    } catch (error) {
      console.error('An error occurred attempting to read the PersistentUploaderService counter from local storage. Expected a number and received ' + this.$$counter);
      try {
        var data = this.$$fileCache && this.$$fileCache.getAll();
        if (isObject(data)) {
          // increment the last key in the existing cache
          var recoveryKeys = Object.keys(data);
          this.$$counter = recoveryKeys.length ? recoveryKeys[recoveryKeys.length - 1] + 1 : 1;

        } else {
          // cache is empty, reset to 1
          this.$$counter = 1;
        }
        storage.set(COUNTER_KEY, '' + this.$$counter);

      } catch (recoveryError) {
        //TODO: How did this even happen??? Crash app now?
        console.error('Failed to recover from error!');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/upload-service/LocalFileDataService.js